import './redirect.css';

import React from 'react';

export type RedirectParams = {
  href: string;
  text: string;
  className?: string;
};

export const Redirect: React.FC<RedirectParams> = ({ href, text, className }) => {
  return (
    <div className={className}>
      <a href={href}>{text}</a>
    </div>
  );
};
